import Vue from 'vue';
import Router, { Route } from 'vue-router';
import _ from 'lodash';
import seekerRoutes from './seekerRoutes';
import providerRoutes from './providerRoutes';
import store from '../store';
import { sendSegmentPageview } from '../lib/segment';

// Utility function to update login links with current return_path
function updateLoginLinks(returnPath: string): void {
  // Update main login links - replace any existing return_path
  document.querySelectorAll('a[href*="/login"]').forEach((link) => {
    const anchorLink = link as HTMLAnchorElement;
    const baseHref = anchorLink.getAttribute('href');
    if (baseHref) {
      // Remove any existing return_path parameter
      const url = new URL(baseHref, window.location.origin);
      url.searchParams.delete('return_path');
      url.searchParams.set('return_path', returnPath);
      anchorLink.href = url.pathname + url.search;
    }
  });
}

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [...seekerRoutes, ...providerRoutes],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // Scroll to saved position
    }
    return { x: 0, y: 0 }; // Scroll to the top
  },
});

router.beforeEach(async (to, from, next) => {
  // get account data if not already fetched
  try {
    await store.dispatch('account/fetchAccountData');
  } catch (error) {
    console.error('Failed to fetch account data', error);
    // redirect to login or show an error page
  }

  return next();
});

router.afterEach((to: Route, from: Route) => {
  const componentTitle = (to.matched[0]?.components?.default as { name?: string })?.name;
  const processedName = _.startCase(_.replace(to.name, /-/g, ' ')) || 'Unknown Page';

  // Update login links with current return_path
  const returnPath = encodeURIComponent(to.fullPath);
  updateLoginLinks(returnPath);

  try {
    sendSegmentPageview(`Sittercity-Web: ${processedName}`, {
      title: componentTitle,
      url: document.location.href,
      path: document.location.pathname,
      referrer: from.fullPath ? document.location.origin + from.fullPath : undefined,
      search: document.location.search || undefined,
    });
  } catch (error) {
    console.error('Segment tracking failed:', error);
  }
});

export default router;
